import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {
  BillsGridResponse,
  CensusFileUploadSummary,
  IBenefitPackage,
  IBill,
  IListBillPackageBenefits,
  IPackageBenefitGroups,
  IPackageShort,
  IRegion,
} from '../models/bills.interface';

@Injectable({
  providedIn: 'root',
})
export class BillsRepository {

  constructor(private http: HttpClient) {}

  getBillsData(pageParams: HttpParams): Observable<BillsGridResponse> {
    const url = `${environment.apiUrl}/api/v1/ListBill/GetListBillPage`;
    return this.http.get<BillsGridResponse>(url, { params: pageParams });
  }

  getGroupCensusReport(id: string): Observable<any> {
    const url = `${environment.apiUrl}/api/v1/Application/${id}/censusreport`;
    return this.http.get(url, { observe: 'response', responseType: 'blob' });
  }

  getBill(id: string): Observable<IBill> {
    const url = `${environment.apiUrl}/api/v1/ListBill/${id}`;
    return this.http.get<IBill>(url);
  }

  createBill(data) {
    const url = `${environment.apiUrl}/api/v1/ListBill`;
    return this.http.post(url, data);
  }

  getPackagesList(): Observable<IPackageShort[]> {
    const url = `${environment.apiUrl}/api/v1/Package`;
    return this.http.get<IPackageShort[]>(url);
  }

  getRegions(): Observable<IRegion[]> {
    const url = `${environment.apiUrl}/api/v1/Region`;
    return this.http.get<IRegion[]>(url);
  }

  getPackageBenefits(regionId: string, altName: string): Observable<IBenefitPackage> {
    const url = `${environment.apiUrl}/api/v1/Package/byregionandaltname`;
    const params = new HttpParams().set('regionId', regionId).set('altName', altName);
    return this.http.get<IBenefitPackage>(url, { params });
  }

  getBenefitGroups(regionId: string, altName: string): Observable<IPackageBenefitGroups> {
    const url = `${environment.apiUrl}/api/v1/Package/benefitgroups`;
    const params = new HttpParams().set('regionId', regionId).set('altName', altName);
    return this.http.get<IPackageBenefitGroups>(url, { params });
  }

  getBillBenefits(id: string): Observable<IListBillPackageBenefits[]> {
    const url = `${environment.apiUrl}/api/v1/ListBill/${id}/benefits`;
    return this.http.get<IListBillPackageBenefits[]>(url);
  }

  saveBillBenefits(id: string, payload: IListBillPackageBenefits[]): Observable<unknown> {
    const url = `${environment.apiUrl}/api/v1/ListBill/${id}/benefits`;
    return this.http.post(url, payload);
  }

  sendAllEnrolmentByMail(groupId: string): Observable<void> {
    const url = `${environment.apiUrl}/api/v1/ListBill/${groupId}/sendEnrolmentByMail`;
    return this.http.get<void>(url);
  }

  sendAllEnrolmentBySms(groupId: string): Observable<void> {
    const url = `${environment.apiUrl}/api/v1/ListBill/${groupId}/sendEnrolmentBySms`;
    return this.http.get<void>(url);
  }

  uploadCensusFile(file, groupId: string): Observable<CensusFileUploadSummary> {
    const url = `${environment.apiUrl}/api/v1/Application/${groupId}/UploadCensusFile`;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('FileName', file.name);
    return this.http.post<CensusFileUploadSummary>(url, formData, {
      headers: { Accept: 'text/plain', enctype: 'multipart/form-data' },
    });
  }
}
